module.exports = __webpack_public_path__ + "img/wrench-screwdriver.5fb7ffdd.svg";